import { render, staticRenderFns } from "./BlockContentVideo.vue?vue&type=template&id=6b056620"
import script from "./BlockContentVideo.vue?vue&type=script&lang=js"
export * from "./BlockContentVideo.vue?vue&type=script&lang=js"
import style0 from "./BlockContentVideo.vue?vue&type=style&index=0&id=6b056620&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports